import styled from 'styled-components';
import detailImg1 from 'src/assets/images/user-mobile/parking/parking-user-detail-djdrone-1.png';
import detailImg2 from 'src/assets/images/user-mobile/parking/parking-user-detail-djdrone-2.png';
import detailWheat from 'src/assets/images/user-mobile/parking/parking-user-detail-wheat.webp';
import { useOutletContext } from 'react-router-dom';
import { IFestivalOutlet } from 'src/interfaces/overview.interface';

import TopFixedBarParkingDetail from './TopFixedBarParkingDetail';
import UserFooter from './UserFooter';

export default function DetailParkingArea() {
  const { festivalId } = useOutletContext<IFestivalOutlet>();

  return (
    <>
      <TopFixedBarParkingDetail />
      <Container>
        <DetailContent>
          <DetailTitleFirst>전체 주차장 위치</DetailTitleFirst>
          <DetailParkingImg
            src={festivalId === 7 ? detailImg1 : detailWheat}
            alt="주차장 위치"
          />
          {festivalId === 7 && (
            <>
              <DetailTitleSecond>1~3구역 세부 주차장 위치</DetailTitleSecond>
              <DetailParkingImg
                src={detailImg2}
                alt="1~3구역 세부 주차장 위치"
              />
            </>
          )}
        </DetailContent>
        <UserFooter />
      </Container>
    </>
  );
}

const Container = styled.div`
  background: #fff;
  @media (min-width: 640px) {
    width: 640px;
    margin: 0 auto;
    background-color: #f4f3f4;
  }
`;

const DetailContent = styled.div`
  hegiht: 100%;
  background: #fff;
  margin-top: 52px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DetailTitleFirst = styled.h2`
  color: var(--Font-02_black, #111);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
  letter-spacing: -0.5px;
  margin: 16px auto 12px auto;
`;

const DetailTitleSecond = styled.h2`
  color: var(--Font-02_black, #111);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px; /* 150% */
  letter-spacing: -0.5px;
  margin: 36px auto 12px auto;
`;

const DetailParkingImg = styled.img`
  width: 100%;
  height: auto;
`;
